import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { MatTableModule } from '@angular/material/table';
import { MainBannerComponent } from './main-banner/main-banner.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { GenerateReportComponent } from './utils/dialogs/generate-report/generate-report.component';
import { BannerEditorComponent } from './banner-editor/banner-editor.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_LOCALE, OwlDateTimeIntl } from 'ng-pick-datetime';
import { NgToggleModule } from 'ng-toggle-button';
import { UiSwitchModule } from 'ngx-ui-switch';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { DropZoneComponent } from './banner-editor/dropzone/drop-zone/drop-zone.component';
import { ValidateComponentComponent } from './banner-editor/validate-employees/validate-component/validate-component.component';
import {AttachmentFunctionsComponente} from './banner-editor/attachment-functions/attachment-functions.component'
import { SafeUrlPipe } from './utils/pipes/safe-url.pipe'
import { OrderBannerComponent } from './order-banners/order-banners.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

export class DefaultIntl extends OwlDateTimeIntl {
  public cancelBtnLabel = 'Cancelar';
  public setBtnLabel = 'Aceptar';
  public rangeFromLabel = 'De';
  public rangeToLabel = 'A';
  hour12AMLabel = 'AM';
  hour12PMLabel = 'PM';
}

@NgModule({
  declarations: [
    AppComponent,
    MainBannerComponent,
    GenerateReportComponent,
    BannerEditorComponent,
    DropZoneComponent,
    ValidateComponentComponent,
    AttachmentFunctionsComponente,
    SafeUrlPipe,
    OrderBannerComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxUiLoaderModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatTableModule,
    MatTabsModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    BrowserAnimationsModule,
    HttpClientModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgToggleModule,
    UiSwitchModule,
    DragDropModule,
    CommonModule
  ],
  providers: [
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'es' },
    { provide: OwlDateTimeIntl, useClass: DefaultIntl },  
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
